import { format } from 'date-fns';
import type { Filters } from 'hooks/store/blocked-products';
import type { FormSchema } from './form-schema';

const d = (date: Date) => format(date, 'yyyy-MM-dd');

export const createFilterParams = (formData: FormSchema): Filters => {
  const { deliveryForecastDate, ...rest } = formData;
  return {
    ...rest,
    ...(deliveryForecastDate?.from && { deliveryForecastDateFrom: d(deliveryForecastDate.from) }),
    ...(deliveryForecastDate?.to && { deliveryForecastDateTo: d(deliveryForecastDate.to) }),
  }
}